import React from "react";
import { Col, Row, Statistic, theme } from "antd";

export interface StatItem {
  key: string;
  label: string;
  value: React.ReactNode;
  prefix?: React.ReactNode;
  suffix?: React.ReactNode;
  /** Ant Design token color key, e.g. "colorSuccess", "colorWarning" */
  colorToken?: "colorPrimary" | "colorSuccess" | "colorWarning" | "colorError" | "colorInfo";
}

interface StatisticsRowProps {
  stats: StatItem[];
}

const StatisticsRow: React.FC<StatisticsRowProps> = ({ stats }) => {
  const { token } = theme.useToken();

  return (
    <Row gutter={[12, 12]}>
      {stats.map((stat) => {
        const valueColor = stat.colorToken ? token[stat.colorToken as keyof typeof token] as string : token.colorText;

        return (
          <Col key={stat.key} xs={12} sm={8} md={6} lg={4} xl={4}>
            <div
              style={{
                background: token.colorFillAlter,
                border: `1px solid ${token.colorBorderSecondary}`,
                borderRadius: token.borderRadiusLG,
                padding: "12px 16px",
                height: "100%",
              }}
            >
              <Statistic
                title={
                  <span style={{ fontSize: 11, fontWeight: 500, color: token.colorTextSecondary }}>
                    {stat.label}
                  </span>
                }
                value={stat.value as any}
                prefix={stat.prefix}
                suffix={stat.suffix}
                valueStyle={{ fontSize: 20, fontWeight: 700, color: valueColor, lineHeight: 1.3 }}
              />
            </div>
          </Col>
        );
      })}
    </Row>
  );
};

export default StatisticsRow;
